import { useEffect, useState } from "react";
import { getMenus, saveMenus } from "../Services";
import {
  FormControl,
  FormLabel,
  Input,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Button,
  Flex,
  Spacer,
  useBoolean,
  Spinner,
  useToast,
  Box,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Stack,
  Checkbox,
  toast,
  Tooltip
} from '@chakra-ui/react';
import { BiSave } from "react-icons/bi";
import { Theme } from "../Theme";

const CheckList = ({ defaultValues, index, list, onChange }) => {
  return <Stack spacing={1} direction='column' style={Theme.StackScroll} pl={1}>
    {Object.entries(list).map((item, cindex) => <Checkbox
      defaultChecked={(!!defaultValues) ? defaultValues.indexOf(item[0]) > -1 : false}
      onChange={onChange}
      key={`${index}-${cindex}`}
      colorScheme={'blue'}
      value={item[0]}>
      {item[1]}
    </Checkbox>
    )}
  </Stack>
}

const MenuPermission = () => {
  const [loader, setLoader] = useBoolean();
  const [menus, setMenus] = useState({});
  const [roles, setRoles] = useState([]);
  const [country, setCountry] = useState([]);
  const toast = useToast();

  const onGetMenus = () => {
    getMenus()
      .then(results => {
        setMenus(results.menus);
        setRoles(results.roles);
        setCountry(results.country);
      });
  }

  const handleSave = () => {
    setLoader.on();
    saveMenus(menus)
      .then(data => {
        toast({
          position: 'bottom-right',
          status: 'success',
          isClosable: true,
          title: 'Your menus have been successfully saved'
        })
      })
      .catch(error => {
        toast({
          position: 'bottom-right',
          status: 'error',
          isClosable: true,
          title: 'We are sorry, an error occured when saving menus, ' + error.message
        })
      })
      .finally(_ => setLoader.off())
  }

  const toggleRole = (item, target) => {
    if (!target.checked) {
      item.roles.splice(item.roles.indexOf(target.value), 1);
    } else {
      item.roles = [...item.roles, target.value];
    }
    console.log(item);
  }

  const toggleCountry = (item, target) => {
    if (!target.checked) {
      item.country.splice(item.country.indexOf(target.value), 1);
    } else {
      item.country = [...item.country, target.value];
    }
    console.log(item);
  }

  useEffect(() => {
    onGetMenus()
  }, []);

  return <>
    <Flex background={'#e9e9e9'} direction={'row'} p={2} alignItems={'flex-end'} justifyContent={'flex-end'}>
      <Button disabled={loader} onClick={handleSave} size={'sm'} colorScheme='blue'>
        <BiSave size={20} /><Spacer w={'10px'} />Save settings
      </Button>
    </Flex>
    <Box style={Theme.Container}>
      <Tabs className="bf-admin-tabs" orientation="vertical">
        <TabList className="bf-admin-tab-list">
          {Object.entries(menus).map((value, index) => <Tab key={`tabs-menus-${index}`} _selected={Theme.TabVerticalActive} style={Theme.TabVertical}>{value[1].name}</Tab>)}
        </TabList>
        <TabPanels style={Theme.Panels}>
          {Object.entries(menus).map((menu, index) =>
            <TabPanel key={`pnl-apik-${index}`} p={0} style={Theme.Panel}>
              <Table variant='striped'>
                <Thead>
                  <Tr>
                    <Th>ID</Th>
                    <Th>Title</Th>
                    <Th>Only for Roles</Th>
                    <Th>Hide for Country</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {menu[1]?.items
                    .map((item, index) => {
                      return <Tr key={`menu-prm-item-${index}`}>
                        <Td>{item.ID}</Td>
                        <Td>
                          <Tooltip label={item.url} aria-label='tooltip'>
                            {item.post_title}
                          </Tooltip>
                        </Td>
                        <Td><CheckList onChange={(event) => toggleRole(item, event.target)} index={`roles-${index}`} list={roles} defaultValues={item.roles} /></Td>
                        <Td><CheckList onChange={(event) => toggleCountry(item, event.target)} index={`country-${index}`} list={country} defaultValues={item.country} /></Td>
                      </Tr>
                    })}

                </Tbody>
              </Table>
            </TabPanel>
          )}
        </TabPanels>
      </Tabs>
      {(loader) ? <Flex style={Theme.Loader}><Spinner size={'lg'} /></Flex> : null}
    </Box>
  </>
}
export default MenuPermission;